import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PenToolIcon, TrendingUpIcon, MailIcon, UsersIcon, ZapIcon, InstagramIcon, LayoutListIcon, LightbulbIcon, BriefcaseIcon, MegaphoneIcon } from 'lucide-react';
const categories = [{
  icon: PenToolIcon,
  title: 'Content Creation',
  desc: 'Blog posts, articles, and copy',
  count: '65 prompts'
}, {
  icon: TrendingUpIcon,
  title: 'Sales',
  desc: 'Pitches, proposals, and closing',
  count: '45 prompts'
}, {
  icon: MailIcon,
  title: 'Emails',
  desc: 'Newsletters, cold outreach, replies',
  count: '50 prompts'
}, {
  icon: UsersIcon,
  title: 'Client Communication',
  desc: 'Onboarding, updates, difficult chats',
  count: '40 prompts'
}, {
  icon: ZapIcon,
  title: 'Productivity',
  desc: 'Time management and focus',
  count: '35 prompts'
}, {
  icon: InstagramIcon,
  title: 'Instagram',
  desc: 'Captions, reels, and stories',
  count: '80 prompts'
}, {
  icon: LayoutListIcon,
  title: 'Organization',
  desc: 'Systems, SOPs, and planning',
  count: '40 prompts'
}, {
  icon: LightbulbIcon,
  title: 'Brainstorming',
  desc: 'Idea generation and strategy',
  count: '55 prompts'
}, {
  icon: BriefcaseIcon,
  title: 'Business',
  desc: 'Operations and management',
  count: '45 prompts'
}, {
  icon: MegaphoneIcon,
  title: 'Marketing',
  desc: 'Campaigns and positioning',
  count: '45 prompts'
}];
export function WhatsInside() {
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };
  return <section id="whats-inside" className="py-32 relative" data-id="element-315">
      <div className="absolute inset-0 bg-gold-radial opacity-10 pointer-events-none" data-id="element-316" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-317">
        <div className="mb-20" data-id="element-318">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-gold text-sm font-bold tracking-[0.2em] uppercase mb-6 block" data-id="element-319">
            What You Get
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl text-offwhite mb-6 tracking-tight leading-[1.05]" data-id="element-320">
            Everything you need, <span className="text-gold" data-id="element-321">organized.</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-muted max-w-2xl" data-id="element-322">
            500 meticulously engineered prompts divided into 10 core
            professional categories. Find exactly what you need in seconds.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-323">
          {categories.map((cat, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} onMouseMove={handleMouseMove} className="relative bg-black-charcoal border border-white/5 p-6 rounded-xl hover:border-gold/30 transition-all duration-300 group hover:-translate-y-1 overflow-hidden" data-id="element-324">
              {/* Cursor Glow Effect */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
            background: `radial-gradient(400px circle at ${mousePos.x}px ${mousePos.y}px, rgba(201, 169, 97, 0.1), transparent 40%)`
          }} data-id="element-325" />

              <div className="relative z-10" data-id="element-326">
                <div className="flex justify-between items-start mb-8" data-id="element-327">
                  <cat.icon className="w-6 h-6 text-gold opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-328" />
                  <span className="text-[10px] font-medium tracking-wider uppercase text-muted bg-white/5 px-2 py-1 rounded" data-id="element-329">
                    {cat.count}
                  </span>
                </div>
                <h3 className="font-display font-bold text-lg text-offwhite mb-2 group-hover:text-gold transition-colors tracking-tight" data-id="element-330">
                  {cat.title}
                </h3>
                <p className="text-sm text-muted" data-id="element-331">{cat.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}